import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { SearchIcon } from '../icons'

export const Search = () => {
  const [searchValue, setSearchValue] = useState('')
  const navigate = useNavigate()

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    if (searchValue.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchValue.trim())}`)
    }
    setSearchValue('')
  }

  return (
    <div className="relative">
      <form
        onSubmit={handleSearchSubmit}
        className="relative w-full h-full bg-search-bg border border-border rounded-lg flex items-center"
      >
        <input
          type="text"
          placeholder="Search For Products, Retailers, Wholesalers..."
          className="w-full h-full px-6 sm:px-8  py-2 font-inter text-search sm:text-base md:text-lg text-foreground-muted bg-transparent border-none outline-none"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          required
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 aspect-square h-[80%] bg-secondary-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-90 transition-all duration-200"
          aria-label="Submit Search"
        >
          <SearchIcon className="w-4 h-4  text-white" />
        </button>
      </form>
    </div>
  )
}
